import { CustomerMediaUsage } from '../modules/customer/types/customer.enum';
import { MediaType } from '../modules/media/mimeType';

export const PDF_DEFAULT_COVER_PATH = '/images/pdf-file.png';
export const VIDEO_DEFAULT_COVER_PATH = '/images/video-file.png';
export const IMAGE_DEFAULT_COVER_PATH = '/images/empty-image.png';
export const FILE_DEFAULT_COVER_PATH = '/images/file-image.svg';

export interface IMedia {
  id?: string;
  url: string;
  position: number;
  coverUrl?: string | null;
  downloadUrl?: string;
  file?: File;
  type: MediaType;
}

export interface IProductMedia {
  id?: string;
  url: string;
  coverUrl?: string | null;
  downloadUrl?: string;
  file?: File;
  type: MediaType;
}

export interface ICustomerMedia {
  id: string;
  filename: string;
  url: string;
  type: MediaType;
  usage: CustomerMediaUsage;
}

export interface ICustomerMediaSortable extends ICustomerMedia {
  position: number;
}

export const mediaSorterAsc = (a: { position: number }, b: { position: number }) =>
  a.position - b.position;

type GetMediaCoverProps = {
  coverUrl?: string | null | undefined;
  url?: string;
  type?: MediaType;
};

export const getMediaCover = ({ coverUrl, url, type }: GetMediaCoverProps) => {
  if (coverUrl && typeof coverUrl === 'string') {
    return coverUrl;
  }
  switch (type) {
    case 'PDF':
      return PDF_DEFAULT_COVER_PATH;
    case 'VIDEO':
      return url || VIDEO_DEFAULT_COVER_PATH;
    case 'FILE':
      return FILE_DEFAULT_COVER_PATH;
    default:
      return url || IMAGE_DEFAULT_COVER_PATH;
  }
};

export type FileCoverUrlProcessor = (files: File[]) => Promise<IMedia>[];

export const readImageAsBase64 = async (file: any): Promise<string | null> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      if (event.target && typeof event.target.result === 'string') {
        resolve(event.target.result);
      } else {
        reject(event?.target?.result);
      }
    };
    reader.onerror = (event) => {
      process.stdout.write('error on read file');
      if (event.target) {
        reject(event.target.result);
      }
      reader.abort();
    };
    reader.readAsDataURL(file);
  });

export const processImageCoverUrl: FileCoverUrlProcessor = (files: File[]) =>
  files.map(async (file: File) => {
    const coverUrl = await readImageAsBase64(file);
    return {
      file,
      coverUrl,
    };
  });

export const processCoverUrlDefault: FileCoverUrlProcessor = (files: File[]) =>
  files.map(async (file: File) => ({
    file,
    coverUrl: IMAGE_DEFAULT_COVER_PATH,
  }));

export const getMediaExtension = (mediaName: string): string => {
  const fullExtension = mediaName.split('.').pop();
  const extension = fullExtension ? fullExtension.slice(0, 3) : '';
  return extension;
};
